export const apcmStages = [
  {
    "id": "enroll",
    "label": "Enroll",
    "summary": "Approve the roster. Obtain consent.",
    "rows": [
      {
        "title": "Approve new patients",
        "owner": "Pear \u2192 APCM coordinator",
        "detail": "Pear prepares the roster. The coordinator approves new additions before outreach. Previously approved patients continue without repeat approval. Approved additions enter the existing consent campaign; no separate go-ahead."
      },
      {
        "title": "Resolve enrollment questions",
        "owner": "APCM coordinator \u00b7 TE + report",
        "detail": "If the patient requests a staff discussion, pause automated consent outreach. Create an EHR task/TE and report item. Resume only after the coordinator records an outcome, using existing consent rules."
      },
      {
        "title": "Draft after valid consent",
        "owner": "Pear",
        "detail": "Prepare the initial care-plan draft automatically. Consent and filing are separate: the filing cap does not throttle consent acquisition."
      }
    ]
  },
  {
    "id": "approve",
    "label": "Prepare & approve",
    "summary": "One reviewing provider. One initial approval.",
    "rows": [
      {
        "title": "Assign the reviewer",
        "owner": "Encounter history \u2192 reviewing provider",
        "detail": "Use the provider with the most visits in the last ten completed encounters; most recent breaks a tie. Insufficient history holds filing and goes to the coordinator. Pear super admins may assign by patient, batch or standing clinic rule."
      },
      {
        "title": "File at a manageable pace",
        "owner": "Pear \u00b7 3 plans / provider / day",
        "detail": "Initial plans: three per provider per Central day through the 17th, with super-admin provider exemptions. Uncapped from the 18th; aim to file before the 28th. Monthly updates are not capped. Late plans stay visible and eligible; never backdate or drop them."
      },
      {
        "title": "Approve before check-ins",
        "owner": "Reviewing provider",
        "detail": "An EHR signature or explicit provider approval in Graham/DaVinci counts. Calls begin the month after consent, contingent on approval. Late approval uses the next eligible opportunity, without another full-month wait. Revisions return to the same provider and keep initial calls on hold. Pending approvals appear for provider and coordinator; no automatic reminders."
      }
    ]
  },
  {
    "id": "support",
    "label": "Review & support",
    "summary": "One full review each month. Shorter weekly follow-through.",
    "rows": [
      {
        "title": "Review the care plan",
        "owner": "First successful check-in of the month",
        "detail": "Complete the full monthly care-plan review. Later weekly calls may be shorter tuck-ins. A successful call does not necessarily mean the review is complete. Resume unfinished sections at the next eligible call; revisit changed sections only. Carry outstanding work into the new month's review while leaving the prior month incomplete."
      },
      {
        "title": "Use the effective cadence",
        "owner": "Monthly or weekly \u00b7 patient preferences first",
        "detail": "Weekly defaults: Thursday attempt, Friday retry only if unsuccessful. Do not duplicate TCM calls. Preserve existing monthly campaign contact windows, retry spacing/caps and APCM holiday policy; TCM's holiday rule does not automatically apply to APCM."
      },
      {
        "title": "Update monthly. Renew annually.",
        "owner": "Provider approval lasts 12 months",
        "detail": "Monthly updates need no new signature and do not reset the approval clock. Renew 12 months after last approval using the latest plan plus changes since the approved version. Overdue renewal does not stop calls: flag the reviewing provider and coordinator. Reassignment preserves approval attribution/date and cadence instruction until changed. Monthly updates do not authorize new clinical orders."
      }
    ]
  },
  {
    "id": "follow",
    "label": "Close the loop",
    "summary": "Assign the action. Keep unresolved work visible.",
    "rows": [
      {
        "title": "Route concerns",
        "owner": "Reviewing provider\u2019s MA \u00b7 coordinator fallback",
        "detail": "Routine concerns go to the reviewing provider's MA, with APCM coordinator fallback if unknown/unavailable. Urgent concerns notify both by TE alongside the approved escalation pathway. Update the same open concern; a recurrence after resolution gets a linked new TE, subject to Burleson's one-open-TE rule."
      },
      {
        "title": "Resolve only completed work",
        "owner": "Pear EHR owner + report",
        "detail": "Successful no-concern calls are assigned to the Pear EHR account and resolved. Do not close unrelated concerns or mark unfinished plan sections complete. Check EHR resolution; carry unresolved concerns into later calls and reports, even if calls stop. No new callback deadlines."
      },
      {
        "title": "Make gaps visible",
        "owner": "APCM coordinator + billing lead",
        "detail": "Separate complete and incomplete monthly reviews. Review status alone does not establish billing eligibility. Provider videos include care-level changes, cadence exceptions, concerns and progress; staff videos show overall progress and work by role. Pear report reviewer approves videos; initial presentations are live, secure delivery is a later phase."
      }
    ]
  }
]
